// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1RZ5X","selects":"Documents_selects__1dK4c"};